import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const UserProfile = () => {
  const { user, isAuthenticated } = useAuth0();

  if (!isAuthenticated) {
    return null;
  }

  const userRoles = user?.['https://dataapp.mallikoviresearchgroup.no/roles'] || [];

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '8px 16px',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      borderRadius: '8px',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      position: 'relative',
      zIndex: 102
    }}>
      {user?.picture && (
        <img 
          src={user.picture} 
          alt={user.name}
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%'
          }}
        />
      )}
      <div>
        <div style={{ fontWeight: '600', fontSize: '14px', color: 'white' }}>
          {user?.name || user?.email}
        </div>
        {userRoles.length > 0 && (
          <div style={{ fontSize: '12px', color: 'rgba(255, 255, 255, 0.8)' }}>
            {userRoles.join(', ')}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserProfile;
